import { create } from "core-js/core/object";

export default {
  /* -------------------------------------------------------------------------- */
  /*                                 List State                                 */
  /* -------------------------------------------------------------------------- */
  loading: false,
  listLoading: false,
  DiamondPricingRecords: [],
  total: 0,
  FilteredCount: 0,
  createLoading: false,
  updateLoading: false,
}
